import httpFactory, { HttpType } from "@/api/httpFactory";
export default {
    async getAll() {
        const http = httpFactory.getHttp(HttpType.Api);
        try {
            const response = await http.get("companies");
            return response.data;
        }
        catch (error) {
            let errorData = error.message;
            if (error.response?.data) {
                errorData = error.response.data.errors ?? error.response.data;
            }
            throw errorData;
        }
    },
    async getInfo() {
        const http = httpFactory.getHttp(HttpType.Api);
        try {
            const response = await http.get("companies/my");
            return response.data;
        }
        catch (error) {
            let errorData = error.message;
            if (error.response?.data) {
                errorData = error.response.data.errors ?? error.response.data;
            }
            throw errorData;
        }
    }
};
